export const OPCAO_EM_BRANCO = [{label:"", data:""}];

export const OPCAO_TODOS = [{label:"Todos", data:null}];

export const CONSTANTE_HORAS = [ 
        {label:"-", data:""},
		{label:"00:00", data:"00:00"},
		{label:"00:15", data:"00:15"},
		{label:"00:30", data:"00:30"},		
		{label:"00:45", data:"00:45"},		
		{label:"01:00", data:"01:00"},
		{label:"01:15", data:"01:15"},
		{label:"01:30", data:"01:30"},		
		{label:"01:45", data:"01:45"},		
		{label:"02:00", data:"02:00"},
		{label:"02:15", data:"02:15"},
		{label:"02:30", data:"02:30"},		
		{label:"02:45", data:"02:45"},		
		{label:"03:00", data:"03:00"},
		{label:"03:15", data:"03:15"},
		{label:"03:30", data:"03:30"},		
		{label:"03:45", data:"03:45"},		
		{label:"04:00", data:"04:00"},
		{label:"04:15", data:"04:15"},
		{label:"04:30", data:"04:30"},		
		{label:"04:45", data:"04:45"},		
		{label:"05:00", data:"05:00"},
		{label:"05:15", data:"05:15"},
		{label:"05:30", data:"05:30"},		
		{label:"05:45", data:"05:45"},		
		{label:"06:00", data:"06:00"},
		{label:"06:15", data:"06:15"},
		{label:"06:30", data:"06:30"},		
		{label:"06:45", data:"06:45"},		
		{label:"07:00", data:"07:00"},
		{label:"07:15", data:"07:15"},
		{label:"07:30", data:"07:30"},		
		{label:"07:45", data:"07:45"},		
		{label:"08:00", data:"08:00"},
		{label:"08:15", data:"08:15"},
		{label:"08:30", data:"08:30"},		
		{label:"08:45", data:"08:45"},		
		{label:"09:00", data:"09:00"},
		{label:"09:15", data:"09:15"},
		{label:"09:30", data:"09:30"},		
		{label:"09:45", data:"09:45"},		
		{label:"10:00", data:"10:00"},
		{label:"10:15", data:"10:15"},
		{label:"10:30", data:"10:30"},		
		{label:"10:45", data:"10:45"},		
		{label:"11:00", data:"11:00"},
		{label:"11:15", data:"11:15"},
		{label:"11:30", data:"11:30"},		
		{label:"11:45", data:"11:45"},		
		{label:"12:00", data:"12:00"},
		{label:"12:15", data:"12:15"},
		{label:"12:30", data:"12:30"},		
		{label:"12:45", data:"12:45"},		
		{label:"13:00", data:"13:00"},
		{label:"13:15", data:"13:15"},
		{label:"13:30", data:"13:30"},		
		{label:"13:45", data:"13:45"},		
		{label:"14:00", data:"14:00"},
		{label:"14:15", data:"14:15"},
		{label:"14:30", data:"14:30"},		
		{label:"14:45", data:"14:45"},		
		{label:"15:00", data:"15:00"},
		{label:"15:15", data:"15:15"},
		{label:"15:30", data:"15:30"},		
		{label:"15:45", data:"15:45"},		
		{label:"16:00", data:"16:00"},
		{label:"16:15", data:"16:15"},
		{label:"16:30", data:"16:30"},		
		{label:"16:45", data:"16:45"},		
		{label:"17:00", data:"17:00"},
		{label:"17:15", data:"17:15"},
		{label:"17:30", data:"17:30"},		
		{label:"17:45", data:"17:45"},		
		{label:"18:00", data:"18:00"},
		{label:"18:15", data:"18:15"},
		{label:"18:30", data:"18:30"},		
		{label:"18:45", data:"18:45"},		
		{label:"19:00", data:"19:00"},
		{label:"19:15", data:"19:15"},
		{label:"19:30", data:"19:30"},		
		{label:"19:45", data:"19:45"},		
		{label:"20:00", data:"20:00"},
		{label:"20:15", data:"20:15"},
		{label:"20:30", data:"20:30"},		
		{label:"20:45", data:"20:45"},		
		{label:"21:00", data:"21:00"},
		{label:"21:15", data:"21:15"},
		{label:"21:30", data:"21:30"},		
		{label:"21:45", data:"21:45"},		
		{label:"22:00", data:"22:00"},		
		{label:"22:15", data:"22:15"},		
		{label:"22:30", data:"22:30"},
		{label:"22:45", data:"22:45"},
		{label:"23:00", data:"23:00"},
		{label:"23:15", data:"23:15"},
		{label:"23:30", data:"23:30"},
		{label:"23:45", data:"23:45"},
		{label:"23:59", data:"23:59"}];

export const CONSTANTE_TIPOS_AVISOS_SEM_TODOS  =[   	
	{label:"Abastecimento", data: "Abastecimento"},
	{label:"Abertura Capô", data:"AberturaCapo"},
	{label:"Abertura Cofre", data:"AberturaCofre"},		
	{label:"Abertura Porta-Malas", data:"AberturaPortaMalas"},
	{label:"Abertura Porta", data:"AberturaPorta"},
	{label:"Abertura Porta Motorista", data:"AberturaPortaMotorista"},
	{label:"Abertura Porta Carona", data:"AberturaPortaCarona"},
	{label:"Abertura Porta Baú Traseira", data:"AberturaPortaBauTraseira"},
	{label:"Abertura Porta Baú Lateral", data:"AberturaPortaBauLateral"},
	{label:"Aceleração Brusca", data:"AceleracaoBrusca"},
	{label:"Acionamento de Embreagem", data:"AcionamentoEmbreagem"},
	{label:"Acionamento Engate", data:"AcionamentoEngate"},
	{label:"Acionamento Caçamba", data:"AcionamentoCacamba"},		
	{label:"Acionamento do Botão de Emergência do Passageiro", data:"AcionamentoEmergenciaPassageiro"},
	{label:"Acionamento do Botão de Emergência do Porta Malas", data:"AcionamentoEmergenciaPortaMalas"},
	{label:"Acionamento do Botão de Emergência do Banco Traseiro", data:"AcionamentoEmergenciaBancoTraseiro"},
	{label:"Alarme de Colisão Frontal", data:"AlarmeColisaoFrontal"},
	{label:"Alarme de Saída de Faixaa", data:"AlarmeSaidaFaixa"},
	{label:"Alarme de distância curta do veículo da frente", data:"AlarmeDistanciaCurtaVeiculoAFrente"},
	{label:"Alarme de Colisão com Pedestre", data:"AlarmeColisaoPedestre"},
	{label:"Alarme de Mudança Frequente de Faixa", data:"AlarmeMudancaFrequenteFaixa"},
	{label:"Alarme de velocidade acima do limite da sinalização", data:"AlarmeVelocidadeAcimaDoLimitePlaca"},
	{label:"Alarme de Obstaculo", data:"AlarmeObstaculo"},
	{label:"Alerta de Ponto Morto", data:"AlertaPontoMorto"},
	{label:"Alerta de Temperatura", data:"AlertaTemperatura"},
	{label:"Antena de GPS desconectada", data:"AntenaGPSDesconectada"},
	{label:"Atraso Evento da Agenda ", data:"AvisoAtrasoAgendaEvento"},	
	{label:"Aviso Veículo Ligado", data:"AvisoVeiculoLigado"},
	{label:"Aviso Veículo Desligado", data:"AvisoVeiculoDesligado"},
	{label:"Aviso Mensagem Teclado", data:"AvisoMensagemTeclado"},
	{label:"Bateria com Carga Baixa", data:"BaixaCargaNaBateria"},
	{label:"Câmara Fria", data:"CamaraFriaLigada"},
	{label:"Comunicação desatualizada", data:"TempoSemConexao"},
	{label:"Curva Acentuada", data:"CurvaAcentuada"},		
	{label:"Desabastecimento", data: "Desabastecimento"},	
	{label:"Desvio de Rota", data:"DesvioRota"},
	{label:"Desviou Atenção da Estrada", data:"MotoristaDesviouAtencao"},
    {label:"Desviou Prolongado da Atenção da Estrada", data:"MotoristaDesviouAtencaoProlongado"},
	{label:"Evento da Agenda ", data:"AvisoAgendaEvento"},		
	{label:"Excesso de Tempo Parado", data:"TempoParadoExcedido"},
	{label:"Excesso de Tempo Parado Ligado", data:"ExcessoTempoParadoLigado"},
	{label:"Excesso de Tempo de Direção", data:"ExcessoTempoDirecao"},
	{label:"Excesso de Velocidade", data:"ExcessoVelocidade"},
	{label:"Excesso Médio de Velocidade", data:"ExcessoMedioVelocidade"},
	{label:"Excesso Grave de Velocidade", data:"ExcessoGraveVelocidade"},	
	{label:"Excesso de Velocidade Na Chuva", data:"ExcessoVelocidadeNaChuva"},
	{label:"Excesso Médio de Velocidade Na Chuva", data:"ExcessoMedioVelocidadeNaChuva"},
	{label:"Excesso Grave de Velocidade Na Chuva", data:"ExcessoGraveVelocidadeNaChuva"},
	{label:"Excesso de Velocidade no Ponto", data:"ExcessoVelocidadePoI"},		
	{label:"Excesso Médio de Velocidade no Ponto", data:"ExcessoMedioVelocidadePoI"},		
	{label:"Excesso Grave de Velocidade no Ponto", data:"ExcessoGraveVelocidadePoI"},		
	{label:"Excessode Velocidade GR", data: "ExcessoVelocidadeGRInicio"},
	{label:"Excessode Velocidade Na Chuva GR", data: "ExcessoVelocidadeNaChuvaGRInicio"},
	{label:"Excesso Velocida na Via", data: "ExcessoVelocidadeVia"},
	{label:"Excesso Medio VelocidadeVia", data: "ExcessoMedioVelocidadeVia"},
	{label:"Excesso Grave VelocidadeVia", data: "ExcessoGraveVelocidadeVia"},
	{label:"Excesso Velocidade na Via na Chuva", data: "ExcessoVelocidadeViaNaChuva"},
	{label:"Excesso Médio Velocidade na Via na Chuva", data: "ExcessoMedioVelocidadeViaNaChuva"},
	{label:"Excesso Grave Velocidade na Via na Chuva", data: "ExcessoGraveVelocidadeViaNaChuva"},
	{label:"Excesso Velocidade na Cidade", data: "ExcessoVelocidadeCidade"},
	{label:"Excesso Medio de Velocidade na Cidade", data: "ExcessoMedioVelocidadeCidade"},
	{label:"Excesso Grave de Velocidade na Cidade", data: "ExcessoGraveVelocidadeCidade"},
	{label:"Excesso Velocidade na Cidade na Chuva", data: "ExcessoVelocidadeCidadeNaChuva"},
	{label:"Excesso Medio de Velocidade na Cidade na Chuva", data: "ExcessoMedioVelocidadeCidadeNaChuva"},
	{label:"Excesso Grave de Velocidade na Cidade na Chuva", data: "ExcessoGraveVelocidadeCidadeNaChuva"},
	{label:"Freada Brusca", data:"FreadaBrusca"},	
	{label:"Frenagem Excessiva", data:"FrenagemExcessiva"},
	{label:"Frenagem Excessiva Grave", data:"FrenagemExcessivaGrave"},
	{label:"Limpador Parabrisas", data:"LimpadorParabrisasLigado"},		
	{label:"Manutenção", data:"EntrouEmManutencao"},	
	{label:"Movimento Indevido", data:"MovimentoIndevido"},		
	{label:"Motorista com Sonolencia", dataTipoAviso:"MotoristaComSonolencia"},
    {label:"Motorista com Alta Sonolencia", data:"MotoristaComAltaSonolencia"},	
	{label:"Motorista Não Cadastrado ", data:"MotoristaNaoCadastrado"},		
	{label:"Motorista Não Autorizado ", data:"MotoristaNaoAutorizado"},	
	{label:"Pedal acelerador acima do limite", data:"PedalAceleradorAcimaLimite"},
	{label:"Ponto Interesse", data:"AvisoPoI"},
	{label:"Prancha Reboque", data:"ReboqueAcionado"},
	{label:"RPM acima do limite", data:"ExcessoRPM"},
	{label:"RPM acima da faixa 4", data:"ExcessoRPMFaixa4"},
	{label:"Saída do Perímetro", data:"SaidaCerca"},
	{label:"Saída de Ponto de Interesse", data:"AvisoSaidaPoI"},
	{label:"Sem Alimentação Externa", data:"SemAlimentacaoExterna"},
	{label:"Sensor Painel Violado", data:"SensorPainelViolado"},	
	{label:"Sensor Entrada 1", data:"AvisoAux0"},
	{label:"Sensor Entrada 2", data:"AvisoAux1"},
	{label:"Sensor Entrada 3", data:"AvisoAux2"},
	{label:"Tampa de Combustível", data:"FechamentoTanqueCombustivel"},
	{label:"Transito em horário não permitido", data:"TransitoEmHorarioNaoPermitido"},
	{label:"Uso de Cigarro pelo Motorista", data:"MotoristaUsandoCigarro"},
    {label:"Uso de Celular pelo Motorista", data:"MotoristaUsandoCelular"},
	{label:"Veiculo Sem Motorista Identificado ", data:"VeiculoSemMotoristaIdentificado"},	
];

export const CONSTANTE_TIPOS_AVISOS  = OPCAO_TODOS.concat(CONSTANTE_TIPOS_AVISOS_SEM_TODOS);

export const CONSTANTE_TIPOS_AVISOS_COM_ACIONAMENTO_DESACIONAMENTO  =[   	
	{label:"Abertura Capô", data:"AberturaCapo"},
	{label:"Abertura Cofre", data:"AberturaCofre"},		
	{label:"Abertura Porta-Malas", data:"AberturaPortaMalas"},
	{label:"Abertura Porta", data:"AberturaPorta"},
	{label:"Abertura Porta Motorista", data:"AberturaPortaMotorista"},
	{label:"Abertura Porta Carona", data:"AberturaPortaCarona"},
	{label:"Abertura Porta Baú Traseira", data:"AberturaPortaBauTraseira"},
	{label:"Abertura Porta Baú Lateral", data:"AberturaPortaBauLateral"},		
	{label:"Acionamento Engate", data:"AcionamentoEngate"},
	{label:"Acionamento Caçamba", data:"AcionamentoCacamba"},			
	{label:"Antena de GPS desconectada", data:"AntenaGPSDesconectada"},	
	{label:"Câmara Fria", data:"CamaraFriaLigada"},
	{label:"Excessode Velocidade GR", data: "ExcessoVelocidadeGRInicio"},
	{label:"Excessode Velocidade Na Chuva GR", data: "ExcessoVelocidadeNaChuvaGRInicio"},	
	{label:"Limpador Parabrisas", data:"LimpadorParabrisasLigado"},			
	{label:"Ponto Interesse", data:"AvisoPoI"},
	{label:"Prancha Reboque", data:"ReboqueAcionado"},	
	{label:"Saída do Perímetro", data:"SaidaCerca"},	
	{label:"Sem Alimentação Externa", data:"SemAlimentacaoExterna"},
	{label:"Sensor Painel Violado", data:"SensorPainelViolado"},	
	{label:"Sensor Entrada 1", data:"AvisoAux0"},
	{label:"Sensor Entrada 2", data:"AvisoAux1"},
	{label:"Sensor Entrada 3", data:"AvisoAux2"},
	{label:"Sensor Entrada 4", data:"AvisoAux3"},
	{label:"Tampa de Combustível", data:"FechamentoTanqueCombustivel"}
];

export const CONSTANTE_TIPO_DESPESA_VEICULO_ARRAY =[
		{label:"Abastecimento Externo", data:"AbastecimentoExterno"},
		{label:"Abastecimento Externo Cartão", data:"AbastecimentoExternoCartao"},
		{label:"Abastecimento Externo à Vista", data:"AbastecimentoExternoAVista"},
		{label:"Abastecimento Interno", data:"AbastecimentoInterno"},
		{label:"Abastecimento Interno Cartão", data:"AbastecimentoInternoCartao"},
		{label:"Alimentação", data:"Alimentacao"},
		{label:"Arla", data:"Arla"},
		{label:"Borracharia", data:"Borracharia"},
		{label:"Balsa", data:"Balsa"},
		{label:"Custo de Viagem", data:"CustoViagem"},
		{label:"Descarregamento", data:"Descarregamento"},
		{label:"Despesa Índice de Produção", data:"DespesaIP"},
		{label:"Diária", data:"Diaria"},		
		{label:"Enlonamento", data:"Enlonamento"},
		{label:"Estacionamento", data:"Estacionamento"},
		{label:"Frete", data:"Frete"},		
		{label:"Hospedagem", data:"Hospedagem"},
		{label:"Lavagem", data:"Lavagem"},
		{label:"Leasing", data:"Leasing"},
		{label:"Licenciamento", data:"Licenciamento"},
		{label:"Lubrificante", data:"Lubrificante"},
		{label:"Manutenção", data:"Manutencao"},
		{label:"Multa", data:"Multa"},
		{label:"Óleo Lubrificante", data:"OleoLubrificante"},
		{label:"Pedagio", data:"Pedagio"},
		{label:"Pneu", data:"Pneu"},
		{label:"Produtividade / NF", data:"Produtividade/NF"},
		{label:"Revisão", data:"Revisao"},
		{label:"Recapagem de Pneu", data:"Recapagem de Pneu"},
		{label:"Salário", data:"Salario"},
		{label:"Seguro", data:"Seguro"},
		{label:"Serviços", data:"Serviços"},		
		{label:"Taxi", data:"Taxi"},
		{label:"Tacografo", data:"Tacografo"},
		{label:"Taxa / Fronteira", data:"Taxa/Fronteira"},
		{label:"Telefone", data:"Telefone"},		
		{label:"Transbordo", data:"Transbordo"},
		{label:"Troca de Peça", data:"TrocaPeca"},		
		{label:"Outro", data:"Outro"}];

export const CONSTANTE_TIPO_DESPESA_VEICULO_ARRAY_OP_TODOS = OPCAO_TODOS.concat(CONSTANTE_TIPO_DESPESA_VEICULO_ARRAY);	
export const CONSTANTE_TIPO_DESPESA_VEICULO_ARRAY_OP_BRANCO = OPCAO_EM_BRANCO.concat(CONSTANTE_TIPO_DESPESA_VEICULO_ARRAY);

export const CONSTANTE_TIPO_RECEITA_VEICULO_ARRAY = [	
	{label:"Frete", data:"FRETE"},		
	{label:"Frete Express", data:"FRETE EXPRESS"},	
	{label:"Frete pago por Cliente", data:"FRETE PAGO POR CLIENTE"},	
	{label:"Outros", data:"OUTROS"}		
];

export const CONSTANTE_TIPO_RECEITA_VEICULO_ARRAY_OP_TODOS = OPCAO_TODOS.concat(CONSTANTE_TIPO_RECEITA_VEICULO_ARRAY);	
export const CONSTANTE_TIPO_RECEITA_VEICULO_ARRAY_OP_BRANCO = OPCAO_EM_BRANCO.concat(CONSTANTE_TIPO_RECEITA_VEICULO_ARRAY);

export const CONSTANTE_TIPO_EVENTO_VEICULO_ARRAY = [
		{label:"Licenciamento", data:"Licenciamento"},
		{label:"Manutenção", data:"Manutencao"},					
		{label:"Manutenção Corretiva", data:"ManutencaoCorretiva"},					
		{label:"Manutenção Preventiva", data:"ManutencaoPreventiva"},					
		{label:"Revisão", data:"Revisao"},
		{label:"Seguro", data:"Seguro"},					
		{label:"Troca de Peça", data:"TrocaPeca"},
		{label:"Outro", data:"Outro"}
	];

export const CONSTANTE_TIPO_EVENTO_VEICULO_ARRAY_OP_TODOS = OPCAO_TODOS.concat(CONSTANTE_TIPO_EVENTO_VEICULO_ARRAY);

export const CONSTANTE_STATUS_EVENTO_AGENDA_ARRAY = [
	{label:"ABERTO", data:"ABERTO"},
	{label:"INFORMADO", data:"INFORMADO"},
	{label:"CONCLUIDO", data:"CONCLUIDO"},
	{label:"CANCELADO", data:"CANCELADO"}
];

export const CONSTANTE_STATUS_EVENTO_AGENDA_ARRAY_OP_TODOS = OPCAO_TODOS.concat(CONSTANTE_STATUS_EVENTO_AGENDA_ARRAY);

export const CONSTANTES_STATUS_VIAGEM_ROTEIRZACAO_ARRAY = [
	{label:"Agendada", data:"AGENDADA"},		
	{label:"Aberta", data:"ABERTA"},
	{label:"Em Andamento", data:"EM_ANDAMENTO"},
	{label:"Cancelada", data:"CANCELADA"},					
	{label:"Finalizada", data:"FINALIZADA"}
];

export const CONSTANTE_OPCAO_STATUS_ITINERARIO = [	
	{label:"Aberta", labelVisita: "Visita Aberta", statusParaVista: true, data:"ABERTO"},		
	{label:"Adiada", labelVisita: "Visita Adiada", statusParaVista: true, data:"ADIADO"},
	{label:"Devolvido", labelVisita: "", statusParaVista: false,  data:"DEVOLVIDO"},
	{label:"Entregue", labelVisita: "Visita Realizada", statusParaVista: true, data:"ENTREGUE"},					
	{label:"Pendente", labelVisita: "Visita Pendente", statusParaVista: true, data:"PENDENTE"},
	{label:"End. Fechado", labelVisita: "End. Fechado", statusParaVista: true, data:"ENDERECO_FECHADO"},					
	{label:"End. Errado", labelVisita: "End. Errado", statusParaVista: true, data:"ENDERECO_ERRADO"},
	{label:"End. Não Localizado", labelVisita: "End. Não Localizado", statusParaVista: true, data:"ENDERECO_NAO_LOCALIZADO"},
	{label:"Não Informado", labelVisita: "Não Informado", statusParaVista: true, data:"NAO_INFORMADO"}
];

export const CONSTANTES_TIPOS_REGISTRO_PARADA = [	
 {label:"Parada programada", data:"PARADA_PROGRAMADA"},
 {label:"Solicitação de motorista", data:"SOLICITACAO_MOTORISTA"},
 {label:"Solicitação externa", data:"SOLICITACAO_EXTERNA"},
 {label:"Solicitação agente rodoviário", data:"SOLICITACAO_AGENTE_RODOVIARIO"},
 {label:"Acidente na Via", data:"ACIDENTE_VIA"},
 {label:"Acidente com o veículo", data:"ACIDENTE_VEICULO"},
 {label:"Defeito no veículo", data:"DEFEITO_VEICULO"},		
 {label:"Troca programada de veículo", data:"TROCA_PROGRAMADA_VEICULO"},
 {label:"Outro", data:"OUTRO"}
];

export const CONSTANTE_OPCAO_TIPOS_DESENHOS_PNEUS_ARRAY = [	
    {label:"Liso", data:"LISO"},
    {label:"Borrachudo", data:"BORRACHUDO"},
    {label:"Misto", data:"MISTO"},
    {label:"Maciço", data:"MACICO"},
    {label:"Outros", data:"OUTROS"}		
];

export const CONSTANTE_OPCAO_STATUS_PNEUS_ARRAY = [	
    {label:"ALMOXARIFADO", data:"ALMOXARIFADO"},
	{label:"SUCATA", data:"SUCATA"},
	{label:"VEICULO", data:"VEICULO"},
	{label:"REFORMA", data:"REFORMA"}	
];

export const CONSTANTE_OPCAO_CONTROLE_PNEU_ARRAY = [	
    {label:"Quilômetro ( CPK )", data:"CPK"},
	{label:"Milha  ( CPM )", data:"CPM"},
	{label:"Hora ( CPH )", data:"CPH"}
];

export const CONSTANTE_OPCAO_VIDA_PNEUS_ARRAY = [	
    {label:"Pneus Novo ( 1a Vida )", data:"1"},
	{label:"1o Recape  ( 2a Vida )", data:"2"},
	{label:"2o Recape  ( 3a Vida )", data:"3"},
	{label:"3o Recape  ( 4a Vida )", data:"4"},
	{label:"4o Recape  ( 5a Vida )", data:"5"},
	{label:"5o Recape  ( 6a Vida )", data:"6"},
	{label:"6o Recape  ( 7a Vida )", data:"7"}
];

export const CONSTANTE_OPCAO_TIPO_AQUISICAO_PNEUS_ARRAY = [	
    {label:"Pneus Novos - Reposição", data:"Pneus Novos - Resposição"},
	{label:"Pneus Novos - Novos Veículos", data:"Pneus Novos - Novos Veículos"},
	{label:"Pneus Em Uso", data:"Pneus Em Uso"},
	{label:"Usados", data:"Usados"},
	{label:"Carcaças", data:"Carcaças"},
	{label:"Pneus Recapados", data:"Pneus Recapados"}	
];

export const CONSTANTE_OPCAO_MOTIVO_PNEU_REFORMA = [	
		{label:"Conserto", data:"CONSERTO"},
		{label:"Reforma", data:"REFORMA"},
		{label:"Conserto + Reforma", data:"CONSERTO+REFORMA"}
];

export const CONSTANTE_OPCAO_RECUSADO = [{label:"Recusado", data:"RECUSADO"}];

export const CONSTANTE_OPCAO_MOTIVO_PNEU_REFORMA_COM_RECUSADO = CONSTANTE_OPCAO_RECUSADO.concat(CONSTANTE_OPCAO_MOTIVO_PNEU_REFORMA);

export const CONSTANTE_TIPO_MENSAGENS_KNOV_ARRAY = [
		{label:'Início de Viagem/ Início de Jornada', data: '*TR,4,0'},
		{label:'Início de Manobra', data: '*TR,4,1'},
		{label:'Início de Manutenção', data: '*TR,4,2'},
		{label:'Início de Carga', data: '*TR,4,3'},
		{label:'Início de Descarga', data: '*TR,4,4'},
		{label:'Espera', data: '*TR,4,5'},
		{label:'Início de Abastecimento', data: '*TR,4,6'},
		{label:'Inicio de Refeição', data: '*TR,4,7'},
		{label:'Descanso', data: '*TR,4,8'},
		{label:'Trânsito Parado', data: '*TR,4,9'},
		{label:'Fim de Jornada', data: '*TR,4,10'},
		{label:'Polícia', data: '*TR,4,11'},
		{label:'Pane', data: '*TR,4,12'},
		{label:'Emergência', data: '*TR,4,13'}
];

export const CONSTANTE_TIPO_MENSAGENS_GETSCALE_ARRAY = [
		{label:'Início de Viagem/ Início de Jornada', data: '4,1'},
		{label:'Fim de Jornada', data: '4,2'},
		{label:'Inicio de Refeição', data: '4,3'},
		{label:'Fim de Refeição', data: '4,4'},
		{label:'Início de Repouso', data: '4,5'},
		{label:'Fim de Repouso', data: '4,6'},
		{label:'Início de Espera', data: '4,7'},
		{label:'Fim de Espera', data: '4,8'},
		{label:'Início Manobra', data: '4,9'},
		{label:'Fim Manobra', data: '4,10'}
];		

export const CONSTANTE_OPCAO_PERIODIZACAO = [	
	{label:"Semanas", data:"SEMANAL"},			
	{label:"Mês/Meses", data:"MENSAL"}
];

export const CONSTANTE_OPCAO_SIM_NAO = [	
	{label:"SIM", data:"SIM"},			
	{label:"NÃO", data:"NÃO"}
];

export const CONSTANTE_OPCAO_SIM_NAO_SEM_ACENTO = [	
	{label:"SIM", data:"SIM"},			
	{label:"NÃO", data:"NAO"}
];

export const CONSTANTE_OPCAO_PERIODIZACAO_AGENDA = [	
	{label:"Dia", data:"DIARIA"},			
	{label:"Semana", data:"SEMANAL"},			
	{label:"Mês", data:"MENSAL"},
	{label:"Ano", data:"ANUAL"}
];

export const CONSTANTE_OPCAO_NOME_ARQUIVO_SOM = [	
	{label:"Notificacao 1", data:"notificacaoAviso.mp3"},			
	{label:"Notificacao 2", data:"notificacaoAviso-2.mp3"},			
	{label:"Notificacao 3", data:"notificacaoAviso-3.mp3"},			
	{label:"Notificacao 4", data:"notificacaoAviso-4.mp3"},			
	{label:"Notificacao 5", data:"notificacaoAviso-5.mp3"},			
	{label:"Notificacao 6", data:"notificacaoAviso-6.mp3"},			
	{label:"Notificacao 7", data:"notificacaoAviso-7.mp3"},			
	{label:"Notificacao 8", data:"notificacaoAviso-8.mp3"},			
	{label:"Notificacao 9", data:"notificacaoAviso-9.mp3"},			
	{label:"Notificacao 10", data:"notificacaoAviso-10.mp3"},			
	{label:"Notificacao 11", data:"notificacaoAviso-11.mp3"},			
	{label:"Notificacao 12", data:"notificacaoAviso-12.mp3"},			
	{label:"Notificacao 13", data:"notificacaoAviso-13.mp3"},			
	{label:"Notificacao 14", data:"notificacaoAviso-14.mp3"},			
	{label:"Notificacao 15", data:"notificacaoAviso-15.mp3"}
];

export const CONSTANTE_OPCAO_UNIDADES_MEDIDA = [
	{label:"unidade", data:"un"},
	{label:"kg", data:"kg"},
	{label:"g", data:"g"},
	{label:"hora", data:"hora"},
	{label:"dia", data:"dia"},
	{label:"ton", data:"ton"},
	{label:"m", data:"m"},
	{label:"km", data:"km"},
	{label:"cm", data:"cm"},	
	{label:"litro", data:"l"},
	{label:"peça", data:"pc"},
	{label:"pacote", data:"pct"},
];

export const CONSTANTE_OPCAO_TIPO_MOVIMENTACAO_ESTOQUE = [
	{label:"Movimentação entre depósitos", data:"MOVIMENTACAO"},
	{label:"Baixa do estoque", data:"BAIXA"},
	{label:"Saída para veículo", data:"SAIDA"},	
	{label:"Retirada do veículo", data:"RETIRADA"},	
];

export const CONSTANTE_OPCAO_TIPO_ROTEIRIZACAO = [
	{label:"Pedidos", data:"PEDIDOS"},
	{label:"Visitas", data:"VISITAS"}	
];

export const CONSTANTE_OPCAO_TIPO_FATURA_FRETE = [
	{label:"Despesa", data:"DESPESA"},
	{label:"Receita", data:"RECEITA"},
	{label:"Não Lançar", data:"NAO_LANCAR"}		
];

export const CONSTANTE_OPCAO_STATUS_OCORRENCIA_VEICULOS = [
	{label:"Aberta", data:"ABERTA"},
	{label:"Cancelada", data:"CANCELADA"},
	{label:"Em Andamento", data:"EM_ANDAMENTO"},
	{label:"Finalizada", data:"FINALIZADA"}
];

export const CONSTANTE_OPCAO_APROVADO_REPROVADO = [	
	{label:"APROVADO", data:"APROVADO"},			
	{label:"REPROVADO", data:"REPROVADO"}
];

export const CONSTANTE_OPCAO_SIM_NAO_RESPOSTA_CHECKLIST = [	
	{label:"SIM", data:"APROVADO"},			
	{label:"NÃO", data:"REPROVADO"}
];

export const CONSTANTE_OPCAO_TIPO_RESPOSTA_CHECKLIST = [	
	{label:"APROVADO/REPROVADO", data:1},
	{label:"SIM/NÃO", data:2}
];

export const CONSTANTE_OPCAO_TIPO_VEICULO_EXTERNO_ARRAY = [	
	{label:"PORTARIA", data:"portaria"},		
	{label:"GERAL", data:"geral"}
];

export const CONSTANTE_OPCAO_TIPO_OCORRENCIA_FOLHA_PONTO_MOTORISTA = [	
	{label:"DSR - Folga", data:"Folga"},		
	{label:"DC - Atestado Médico", data:"AtestadoMedico"},		
	{label:"COM - Compensação Banco de Horas", data:"CompensacaoBancoHoras"},		
	{label:"Casamento/Nascimento/óbito", data:"Art473"},		
	{label:"AFT - Asfastamento", data:"Afastamento"},		
	{label:"FER - Férias", data:"Ferias"},		
	{label:"SV - Sem Viagens", data:"SemViagem"},		
	{label:"SUS - Suspensão", data:"Suspensao"}	
];

export const CONSTANTE_OPCAO_STATUS_RESPOSTA_CHECKLIST_ARRAY = [	
	{label:"Validado", data:"VALIDADO"},		
	{label:"Não Validado", data:"NAO_VALIDADO"},
	{label:"Pendente", data:"PENDENTE"}	
];